import React from 'react'
import Icon from 'components/icon'
import './loadingDots.css'

const LoadingDots = () => (
  <span className="loading-dots">
    <span><Icon>circle</Icon></span>
    <span><Icon>circle</Icon></span>
    <span><Icon>circle</Icon></span>
  </span>
)

export default LoadingDots
